export type Space =
    | 'none'
    | 'space2'
    | 'space3'
    | 'space4'
    | 'space5'
    | 'space6'
    | 'space7'
    | 'space8'
    | 'space9'
    | 'space10'
    | 'space11'
    | 'space12'
    | 'space13'
    | 'space14'
    | 'space15'
    | 'space16'
    | 'quarterGutter'
    | 'halfGutter'
    | 'gutter'
    | 'doubleGutter'
    | 'oneAndHalfGutter'
    | 'tripleGutter'
    | 'textLarge'
    | 'textSmall'
    | 'auto';

// Unitless spaces
export const pxSpace2 = 2;
export const pxSpace3 = 3;
export const pxSpace4 = 5;
export const pxSpace5 = 7;
export const pxSpace6 = 10;
export const pxSpace7 = 15;
export const pxSpace8 = 20;
export const pxSpace9 = 22;
export const pxSpace10 = 30;
export const pxSpace11 = 35;
export const pxSpace12 = 45;
export const pxSpace13 = 50;
export const pxSpace14 = 60;
export const pxSpace15 = 90;
export const pxSpace16 = 120;
export const pxQuarterGutter = pxSpace5;
export const pxHalfGutter = pxSpace7;
export const pxGutter = pxSpace10;
export const pxDoubleGutter = pxSpace14;
export const pxOneAndHalfGutter = pxSpace12;
export const pxTripleGutter = pxSpace15;

// These records include units as they are used directly in Styled Components CSS
export const none = '0';
export const space2 = pxSpace2 + 'px';
export const space3 = pxSpace3 + 'px';
export const space4 = pxSpace4 + 'px';
export const space5 = pxSpace5 + 'px';
export const space6 = pxSpace6 + 'px';
export const space7 = pxSpace7 + 'px';
export const space8 = pxSpace8 + 'px';
export const space9 = pxSpace9 + 'px';
export const space10 = pxSpace10 + 'px';
export const space11 = pxSpace11 + 'px';
export const space12 = pxSpace12 + 'px';
export const space13 = pxSpace13 + 'px';
export const space14 = pxSpace14 + 'px';
export const space15 = pxSpace15 + 'px';
export const space16 = pxSpace16 + 'px';
export const quarterGutter = pxQuarterGutter + 'px';
export const halfGutter = pxHalfGutter + 'px';
export const gutter = pxGutter + 'px';
export const doubleGutter = pxDoubleGutter + 'px';
export const oneAndHalfGutter = pxOneAndHalfGutter + 'px';
export const tripleGutter = pxTripleGutter + 'px';
export const textLarge = '1.6rem';
export const textSmall = '0.8rem';
export const auto = 'auto';

// Default sizes set in an object, useful for key lookups/Storybook
// spaces should still be used directly in components
export const sizes: Record<Space, string> = {
    none,
    space2,
    space3,
    space4,
    space5,
    space6,
    space7,
    space8,
    space9,
    space10,
    space11,
    space12,
    space13,
    space14,
    space15,
    space16,
    quarterGutter,
    halfGutter,
    gutter,
    doubleGutter,
    oneAndHalfGutter,
    tripleGutter,
    textLarge,
    textSmall,
    auto,
};

// replaces cta-icon, back-icon, forward-icon
export const inlineIcon = space4;

// replaces icon offset prop
export const iconOffset = '0.3em';

const largeHeading = { top: 0, bottom: textLarge };
const smallHeading = { top: 0, bottom: textSmall };

export const typography = {
    h0: largeHeading,
    h1: largeHeading,
    h2: largeHeading,
    h3: largeHeading,
    h4: largeHeading,
    h5: smallHeading,
    h6: smallHeading,
    h7: smallHeading,
    paragraph: textLarge,
    blockquote: textLarge,
    hr: textLarge,
    ul: textLarge,
    ol: textLarge,
};

export const layout = {
    sectionTop: pxDoubleGutter,
    sectionBottom: pxTripleGutter,
    smallSectionTop: pxOneAndHalfGutter,
    smallSectionBottom: pxDoubleGutter,

    twoColumnLayout: {
        bottomSpacing: {
            all: pxDoubleGutter,
            small: pxOneAndHalfGutter,
            medium: pxOneAndHalfGutter,
        },
        bottomDistance: {
            all: pxOneAndHalfGutter,
            small: pxGutter,
            medium: pxGutter,
        },
    },

    contentHeader: {
        topSpacing: {
            base: {
                all: pxOneAndHalfGutter,
                small: pxGutter,
                medium: pxGutter,
            },
            compact: {
                all: pxSpace9,
                small: pxSpace7,
                medium: pxSpace7,
            },
        },
        bottomSpacing: {
            all: pxOneAndHalfGutter,
            small: pxGutter,
            medium: pxGutter,
        },
        backDistance: pxGutter,
        menuDistance: pxGutter,
    },

    contentBody: {
        topSpacing: {
            base: {
                all: pxGutter,
                small: pxHalfGutter,
                medium: pxHalfGutter,
            },
            spacious: {
                all: pxDoubleGutter,
                small: pxOneAndHalfGutter,
                medium: pxOneAndHalfGutter,
            },
        },
        bottomSpacing: {
            all: pxTripleGutter,
            small: pxDoubleGutter,
            medium: pxDoubleGutter,
        },
    },
};
